// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 21:50:53

export default {
  "id": "helix-crush",
  "slug": "helix-crush",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/1900ce5bb7d344e3b12600f136c0a723-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/1900ce5bb7d344e3b12600f136c0a723/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Helix Crush",
      "description": "\"The gameplay is very simple and can be accomplished with only one finger, yet it will also bring you countless challenges and fun. You need to jump and fall through the helix tower, cutting through the colorful fruit and cake slices on the way. But be careful! There are many obstacles and traps along the way, and it will be up to your reflexes and luck to get through them.",
      "instructions": "Using the arrow keys to play the game.",
      "genres": [
        "Casual",
        "Puzzle"
      ],
      "tags": [
        "1player",
        "blade"
      ]
    },
    "zh-CN": {
      "title": "螺旋破碎",
      "description": "游戏玩法非常简单，只需一个手指就能完成，但它也会给你带来无数挑战和乐趣。你需要跳跃并穿过螺旋塔，沿途切割彩色水果和蛋糕切片。但小心！沿途有众多障碍和陷阱，能否通过取决于你的反应速度和运气。",
      "instructions": "使用方向键玩游戏。",
      "genres": [
        "休闲",
        "解谜"
      ],
      "tags": [
        "1玩家",
        "刀"
      ]
    },
    "zh-TW": {
      "title": "螺旋粉碎",
      "description": "遊戲操作非常簡單，只需用一根手指即可完成，但它也會帶來無數挑戰和樂趣。你必須跳躍並穿過螺旋塔，沿途中切割過五顏六色的水果和蛋糕片。但要注意！路上有許多障礙和陷阱，能否通過取決於你的反應和運氣。",
      "instructions": "使用方向鍵玩遊戲。",
      "genres": [
        "休闲",
        "拼圖"
      ],
      "tags": [
        "1玩家",
        "刀刃"
      ]
    },
    "zh-HK": {
      "title": "螺旋碎擊",
      "description": "遊戲操作非常簡單，只需一個手指即可完成，但同時也會帶來無數挑戰和樂趣。你必須跳躍並穿過螺旋塔，途中切過彩色的水果和蛋糕片。但要小心！沿途中充滿了各種障礙和陷阱，能否通過全賴你的反應和運氣。",
      "instructions": "使用方向鍵玩遊戲。",
      "genres": [
        "隨意",
        "謎題"
      ],
      "tags": [
        "1玩家",
        "刀刃"
      ]
    },
    "ja": {
      "title": "ヘリックスクラッシュ",
      "description": "ゲームプレイは非常にシンプルで、一指で遊べますが、無数の挑戦と楽しみをもたらします。ヘリックスタワーをジャンプして通過し、道中に並ぶ色とりどりの果物やケーキのスライスを切ることが必要です。しかし、気をつけてください！道中には多くの障害物と罠があり、それらを乗り越えるのはあなたの反射神経と運気が問われることになります。",
      "instructions": "ゲームをプレイするには、矢印キーを使用してください。",
      "genres": [
        "カジュアル",
        "パズル"
      ],
      "tags": [
        "1プレイヤー",
        "ブレード"
      ]
    },
    "ko": {
      "title": "헬릭스 크러쉬",
      "description": "게임 플레이는 매우 간단하며 한 손으로도 완료할 수 있지만, 그럼에도 불구하고 무수한 도전과 즐거움을 가져다줍니다. 회전 터널을 뛰어넘고, 도로에 있는 다양한 과일과 케이크 슬라이스를 잘라야 합니다. 하지만 주의하세요! 길 위에는 많은 장애물과 덫이 있으며, 이들을 극복하는 것은 당신의 반사 신경과 운명에 달려 있습니다.",
      "instructions": "게임을 플레이할 때 아이콘 키를 사용하세요.",
      "genres": [
        "캐주얼",
        "퍼즐"
      ],
      "tags": [
        "1플레이어",
        "검"
      ]
    },
    "fr": {
      "title": "Helix Crush",
      "description": "Le gameplay est très simple et peut être accompli avec seulement un doigt, mais il vous apportera également de nombreux défis et amusement. Vous devez sauter et tomber à travers la tour en hélice, en coupant les fruits et les tranches de gâteau colorés sur votre chemin. Mais soyez prudent ! Il y a de nombreuses obstacles et pièges en route, et il dépendra de vos réflexes et de votre chance pour les traverser.",
      "instructions": "Utilisez les touches fléchées pour jouer au jeu.",
      "genres": [
        "Facile",
        "Puzzle"
      ],
      "tags": [
        "1 joueur",
        "lame"
      ]
    }
  }
};
